import Plan from "./Plan";
import classes from "./pocketWifi.module.css";
import { useDispatch, useSelector } from "react-redux";
import { orderActions } from "../../store/orderSlice";
import { useEffect } from "react";

function PocketWifiPlans(props) {
  const dispatch = useDispatch();
  const selectedPlan = useSelector((state) => state.order.contractPlan);
  const wifiProductPrice = useSelector((state) => state.order.wifiProductPrice);
  const shopCode = useSelector((state) => state.order.shopCode);

  const submitSelectedBundle = (event, planText) => {
    return;
  };
  const submitWifiProductPrice = (price) => {
    dispatch(orderActions.setWifiProductPrice(price));
    return;
  };

  const is300Wifi = selectedPlan === "ポケットWifi2";
  const is100Wifi = selectedPlan === "ポケットWifi";

  const isMainOffice = shopCode === "00000001";

  useEffect(() => {
    if (!isMainOffice) {
      dispatch(orderActions.setWifiProductPrice(14000));
    }
  }, []);

  return (
    <div className={classes.dataSmsPlansContainer}>
      {props.unitPrice && isMainOffice && (
        <Plan
          taxAmount={7700}
          onSelected={() => submitWifiProductPrice(7700)}
          type={"pocketWifi"}
          planDescription={"プレミアムスティック"}
          buttonActive={wifiProductPrice === 7700}
        />
      )}
      {props.unitPrice && (
        <Plan
          taxAmount={14000}
          onSelected={() => submitWifiProductPrice(14000)}
          type={"pocketWifi"}
          planDescription={"スカイセブンのWi-Fi"}
          buttonActive={wifiProductPrice === 14000}
        />
      )}

      {is100Wifi && props.planList && (
        <Plan
          taxAmount={6600}
          onSelected={submitSelectedBundle}
          planDescription={"100GB/月"}
          type={"pocketWifi"}
          buttonActive={is100Wifi}
        />
      )}
      {is300Wifi && props.planList && (
        <Plan
          taxAmount={9350}
          onSelected={submitSelectedBundle}
          planDescription={"300GB/月"}
          type={"pocketWifi"}
          buttonActive={is300Wifi}
        />
      )}
    </div>
  );
}
export default PocketWifiPlans;
